import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { UserModel } from 'src/core/account/models/registerUser.model';
import { CommonSandbox } from 'src/core/common/common.sandbox';
import { USER_ROLES } from 'src/core/helpers/constants.enum';
import { AppSettingService } from 'src/core/services/app.settings';
import { MessageService } from 'src/core/services/messages.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'dashboard';
    private subs: Subscription[] = [];

    constructor(
        public commonSandbox: CommonSandbox,
        private translate: TranslateService,
        private accountSandbox: AccountSandbox,
        private router: Router,
        private appSettings: AppSettingService,
        private message: MessageService,
        @Inject(DOCUMENT) private document: Document,
        private titleService: Title,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
        this.document.documentElement.lang = this.translate.currentLang;

        const appTitle = this.titleService.getTitle();

        this.checkCurrentUser();

        this.subs.push(this.accountSandbox.getCurrentUserData$.subscribe((res: UserModel) => {
            if (res) {
                this.appSettings.setCurrentUser(res);
            }
        }));

        this.subs.push(this.accountSandbox.doLogOutEmitted$.subscribe(res => {
            if (res) {
                localStorage.clear();
                sessionStorage.clear();
                this.accountSandbox.doClearLoginState();
                this.accountSandbox.doLogoutSuccess();
                this.appSettings.clerCurrentUser();
                this.router.navigate(['login']);
                this.message.log('User logouted!');
            }
        }));
        this.subs.push(this.accountSandbox.loginUserData$.subscribe(user => {
            if (user) {
                this.appSettings.setCurrentUser(user);
                // this.checkCurrentUser();

                // this.accountSandbox.doGetCurrentUser();
            }
        }));
    }

    private checkCurrentUser(): void {
        if (!this.appSettings.cureentUser && this.appSettings.getUserToken()) {
            // console.log('[Core] - do get current user');

            // this.accountSandbox.doGetCurrentUser();
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}
